import React, { useState } from 'react';
import Chart from 'react-apexcharts';




export const Fuel = () => {

  
  const [state, setstate] = useState({

    options: {
      
      chart: {
        id: "basic-bar",
       
      },
      title: {
        text: 'Fuel Intake Every Month'
    },
      xaxis: {
        categories: ['january', 'February', 'March', 'April', 'May', 'June', 'July', 'August','September','October','November','December']
      },
      colors:['#200E3A','#43766C'],
      
      yaxis:{
         type : 'value'
      }
    },
    series: [
      {
        name: "2022-2023",
        data: [105, 110, 80, 70, 55, 80, 90, 100, 75,80,100,100],
        smooth: 0.25,
              
                animationEasing: 'elasticInOut',
                animationDuration: 1200,
                areaStyle: {},

    },
    {
        name: "2023-2024",
                data: [90, 100, 80, 105, 50, 75, 90, 80,90,110,80,95],
                smooth: 0.25,
                
                      
                        animationEasing: 'elasticInOut',
                        animationDuration: 1200,
                        areaStyle: {},
    }
    ]

  })

  

  return (
    <div className='container text-center  mx-auto mt-5'>
         <h1>Fuel Intake</h1>
        <div className='mt-5  mx-auto'>
        <Chart
              options={state.options}
              series={state.series}
              type="line"
              width="100%"
              height="400px"
              
            />
    </div>
    </div>
   
  )
}

